import { useLang } from '../../context/LangContext'

export default function LangToggle({ className = '' }) {
  const { lang, setLang } = useLang()

  const handleLanguageChange = (selectedLang) => {
    setLang(selectedLang)
    localStorage.setItem('language', selectedLang)
  }

  return (
    <div className={`lang-toggle ${className}`}>
      <button
        type="button"
        className={`lang-toggle__btn ${
          lang === 'en' ? 'lang-toggle__btn--active' : ''
        }`}
        onClick={() => handleLanguageChange('en')}
        aria-label="Switch to English"
      >
        EN
      </button>

      <button
        type="button"
        className={`lang-toggle__btn ${
          lang === 'bm' ? 'lang-toggle__btn--active' : ''
        }`}
        onClick={() => handleLanguageChange('bm')}
        aria-label="Tukar ke Bahasa Melayu"
      >
        BM
      </button>
    </div>
  )
}